import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import { toast } from "wc-toast";
import { apiGet, apiPost } from "../utils/apiFetch";
import pathObj from "../utils/apiPath";
import obj from "../utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import { isEmpty, startCase } from "lodash";
const SportSettingNew = () => {
  const [data, setData] = useState(obj.settingArray);
  const [select, setSelect] = useState("cricket");
  const [getInplay, setInplay] = useState(0);
  const [result, setResult] = useState([]);
  const parmas = useParams();
  const navigate = useNavigate();
  const handelInPlay = (value) => {
    setInplay(value);
  };

  const handelChange = (e, type, key) => {
    let limit = result?.find((res) => {
      return res?.type == type;
    });
    let temp = data.map((res) => {
      return res.type === type && e.target.name !== "onShow"
        ? {
            ...res,
            [e.target.name]: Number(e.target.value),
            ["maxError"]:
              key == "maxAmount"
                ? Number(e.target.value) >= limit?.maxAmount + 1
                  ? true
                  : false
                : res?.maxError,
            ["minError"]:
              key == "minAmount"
                ? Number(e.target.value) >= limit?.minAmount + 1
                  ? true
                  : false
                : res?.minError,
            ["maxProfitError"]:
              key == "maxProfit"
                ? Number(e.target.value) >= limit?.maxProfit + 1
                  ? true
                  : false
                : res?.maxProfitError,
            ["oddLimitError"]:
              key == "oddLimit"
                ? Number(e.target.value) >= limit?.oddsLimit + 1
                  ? true
                  : false
                : res?.oddLimitError,
            ["betDelayError"]:
              key == "betDelay"
                ? limit?.betDelay - 1 >= Number(e.target.value)
                  ? true
                  : false
                : res?.betDelayError,
          }
        : res.type === type && e.target.name === "onShow"
        ? { ...res, onShow: e.target.checked ? "1" : "0" }
        : res;
    });
    setData(temp);
  };

  const onSubmit1 = async (item) => {
    try {
      let response = await apiPost(pathObj.sportSetting, {
        ...item,
        sportType: select,
        userId: parmas.id,
        userType: parmas.type,
      });
      if (response?.data?.success) {
        getDetail();
        toast.success(response?.data?.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getDetail = async () => {
    try {
      let response = await apiGet(
        pathObj.sportSetting +
          `?userId=${parmas?.id}&userType=${parmas?.type}&sportType=${select}`
      );
      if (response?.data?.success) {
        if (response?.data?.results?.length > 0) {
          for (let temp of response?.data?.results) {
            setData((current) => {
              return current.map((res) => {
                if (res.type == temp.type) {
                  return {
                    ...res,
                    minAmount: temp.minAmount,
                    maxAmount: temp.maxAmount,
                    betDelay: temp.betDelay,
                    onShow: temp.onShow ? "1" : "0",
                    oddsLimit: temp.oddsLimit,
                    maxProfit: temp.maxProfit,
                  };
                } else {
                  return res;
                }
              });
            });
          }
        } else {
          setData(obj.settingArray);
        }
      }
    } catch (error) {}
  };
  const getData = async () => {
    const { status, data: response_users } = await apiGet(
      pathObj.getSportSettingNew,
      {
        userId: parmas?.id,
        userType: parmas?.type,
        sportType: select,
      }
    );
    if (status === 200) {
      if (response_users.success) {
        let result = response_users?.results;
        if (result?.length > 0) {
          setResult(result);
        }
      }
    }
  };

  useEffect(() => {
    if (!isEmpty(parmas?.id) && !isEmpty(select)) {
      setData(obj?.settingArray);
      getDetail();
      getData();
    }
  }, [parmas, select]);

  return (
    <div>
      <section className="set-limit-sec py-4">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center w-100">
            <h5 class="text-blue">Sport Setting - {startCase(parmas?.type)}</h5>
            <Button className="btn btn-danger" onClick={() => navigate(-1)}>
              Close
            </Button>
          </div>

          <Form className="p-3">
            <Row className="align-items-center">
              <Col md={3}>
                <Form.Group className="d-flex align-items-center mb-3  find-member-sec ">
                  <Form.Label className="pe-2 mb-0 w-75">
                    Select Sports
                  </Form.Label>
                  <Form.Select
                    value={select}
                    onChange={(e) => {
                      setSelect(e.target.value);
                    }}
                    aria-label="Default select example w-auto"
                  >
                    <option value="cricket">Cricket</option>
                    <option value="soccer">Soccer</option>
                    <option value="tennis">Tennis</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Form>
              {data &&
                data?.map((item) => {
                  let limit = result?.find((res) => {
                    return res?.type == item?.type;
                  });
                  return (
                    <Row className="align-items-center">
                      <h2 className="common-heading">
                        {obj.settingHeading[item.type]}
                      </h2>
                      <Col xl={3} lg={3} sm={6}>
                        <Form.Group className="d-flex align-items-center mb-2">
                          <Form.Label className="pe-2 mb-0 w-lg-auto">
                            Min Amount
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="minAmount"
                            placeholder="Min Amount"
                            value={item.minAmount}
                            onChange={(e) => {
                              handelChange(e, item.type, "minAmount");
                            }}
                          />
                        </Form.Group>
                        {item.minError && (
                          <span style={{ color: "red", fontSize: "14px" }}>
                            Min amount should be greater than {limit?.minAmount}
                          </span>
                        )}
                      </Col>
                      <Col xl={3} lg={3} sm={6}>
                        <Form.Group className="d-flex align-items-center mb-2">
                          <Form.Label className="pe-2 mb-0 w-lg-auto">
                            Max Amount
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="maxAmount"
                            placeholder="Max Amount"
                            value={item.maxAmount}
                            onChange={(e) => {
                              handelChange(e, item.type, "maxAmount");
                            }}
                          />
                        </Form.Group>
                        {item.maxError && (
                          <span style={{ color: "red", fontSize: "14px" }}>
                            Max amount should be less than or equal to{" "}
                            {limit?.maxAmount}
                          </span>
                        )}
                      </Col>

                      <Col xl={2} lg={2} sm={6}>
                        <Form.Group className="d-flex align-items-center mb-2">
                          <Form.Label className="pe-2 mb-0">
                            Max Profit
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="maxProfit"
                            placeholder="Max Profit"
                            value={item.maxProfit}
                            onChange={(e) =>
                              handelChange(e, item.type, "maxProfit")
                            }
                          />
                        </Form.Group>
                        {item.maxProfitError && (
                          <span style={{ color: "red", fontSize: "14px" }}>
                            Max Profit should be less than or equal to{" "}
                            {limit?.maxProfit}
                          </span>
                        )}
                      </Col>
                      <Col xl={2} lg={2} sm={6}>
                        <Form.Group className="d-flex align-items-center mb-2">
                          <Form.Label className="pe-2 mb-0">
                            Odds Limit
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="oddsLimit"
                            placeholder="Odds Limit"
                            value={item.oddsLimit}
                            onChange={(e) =>
                              handelChange(e, item.type, "oddLimit")
                            }
                          />
                        </Form.Group>
                        {item.oddLimitError && (
                          <span style={{ color: "red", fontSize: "14px" }}>
                            Odd Limit should be less than or equal to{" "}
                            {limit?.oddsLimit}
                          </span>
                        )}
                      </Col>
                      <Col xl={2} lg={2} sm={6}>
                        <Form.Group className="d-flex align-items-center mb-2">
                          <Form.Label className="pe-2 mb-0">
                            Bet Delay
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="betDelay"
                            placeholder="Bet Delay"
                            value={item.betDelay}
                            onChange={(e) =>
                              handelChange(e, item.type, "betDelay")
                            }
                          />
                        </Form.Group>{" "}
                        {item.betDelayError && (
                          <span style={{ color: "red", fontSize: "14px" }}>
                            Bet Delay should be greater than {limit?.betDelay}
                          </span>
                        )}
                      </Col>
                      <Col lg={2} sm={6}>
                        <Form.Check
                          label="ON (IS SHOWING)"
                          className="mb-2"
                          name="onShow"
                          checked={item.onShow == 1 ? true : false}
                          onChange={(e) => handelChange(e, item.type)}
                        />
                      </Col>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <Button
                          className="green-btn"
                          onClick={() => onSubmit1(item)}
                        >
                          Set Limit
                        </Button>
                      </div>
                    </Row>
                  );
                })}
              {/* <Row className="align-items-center">
                <h2 className="common-heading">Before Inplay</h2>
                <Col xl={3} lg={3} sm={6}>
                  <Form.Group className="d-flex align-items-center mb-2">
                    <Form.Label className="pe-2 mb-0 w-lg-auto">
                      Minutes
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="minutes"
                      placeholder="Minutes"
                      value={getInplay}
                      onChange={(e) => {
                        if (Number(e.target.value)) {
                          handelInPlay(e.target.value, true);
                        } else {
                          handelInPlay(e.target.value, false);
                        }
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row> */}
            </Form>
          </Form>
        </Container>
      </section>
    </div>
  );
};

export default SportSettingNew;
